import React, { useEffect, useState } from "react";
import { ListSelectorProps } from "./types";
import classes from "./ListSelector.module.scss";

const ITEMS_QNT_SHORT_MODE = 10;

const ListSelector = ({ options, onItemSelected }: ListSelectorProps) => {
    const [isShortMode, setIsShortMode] = useState(true);
    const [isShortModePossible, setIsShortModePossible] = useState(true);
    const data = isShortMode ? options.slice(0, ITEMS_QNT_SHORT_MODE) : options;
    useEffect(() => {
        if (options.length <= ITEMS_QNT_SHORT_MODE) {
            setIsShortModePossible(false);
        } else {
            setIsShortModePossible(true);
        }
    }, [options]);

    const toggleMode = (e: React.MouseEvent) => {
        e.preventDefault();
        setIsShortMode(!isShortMode);
    };

    return (
        <div className={classes.ListSelector}>
            <ul
                style={{
                    marginBottom: isShortModePossible ? 30 : 0
                }}
            >
                {data.map((el) => {
                    return (
                        <li key={el.label}>
                            <a
                                onClick={(e) => {
                                    e.preventDefault();
                                    onItemSelected(el);
                                }}
                                href=""
                            >
                                <span>{el.label}</span>
                            </a>
                        </li>
                    );
                })}
            </ul>
            {isShortModePossible && (
                <a onClick={toggleMode} className={classes.ToggleSwitcher} href="#">
                    {isShortMode ? "Показать еще" : "Показать меньше"}
                </a>
            )}
        </div>
    );
};
export default ListSelector;